import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
// import { auth } from 'firebase/app';
import { AngularFireAuth } from "@angular/fire/compat/auth";
import * as firebase from "firebase/auth";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { MessageService } from "./message.service";
import { isPlatformBrowser } from "@angular/common";
import { take } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  user: any;
  auth: any;

  constructor(
    public afAuth: AngularFireAuth,
    public afs: AngularFirestore,
    public mgsService: MessageService,
    public router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.auth = firebase.getAuth();
  }

  checkuser(path: String | boolean) {
    //console.log("came in");
    if (isPlatformBrowser(this.platformId)) {
      const user: any = sessionStorage.getItem("userData")
        ? sessionStorage.getItem("userData")
        : null;

      this.user = user;
      const url = path || this.router.url;
      if (!user) {
        this.router.navigate(["/login"]);
        return true;
      } else {
        if (url == "/login") {
          return true;
        } else {
          return true;
        }
      }
    }
    return true;
  }

  async login(email: string, password: string): Promise<void> {
    try {
      const result = await this.afAuth.signInWithEmailAndPassword(
        email,
        password
      );
      const user = result.user;

      if (!user) {
        this.mgsService.showMessage("Login failed. Please try again.", 5000);
        return;
      }

      const userRef = this.afs.doc(`userMaster/${user.uid}`);
      const snapshot = await userRef.get().toPromise();

      if (!snapshot.exists) {
        this.mgsService.showMessage("User not found in system.", 5000);
        return;
      }

      const data = snapshot.data();

      if (data["inActive"]) {
        this.mgsService.showMessage(
          "User account is inactive. Please contact administration.",
          5000
        );
        return;
      } else if (data["role"] === "admin") {
        this.mgsService.showMessage(
          "This account is an admin account. Please use the admin app.",
          5000
        );
        return;
      }

      this.user = data;

      if (isPlatformBrowser(this.platformId)) {
        await this.checkSubscriptionStatus(data);
      }
    }
    // catch (error) {
    //   console.error(error);
    //   this.mgsService.showMessage(
    //     error.message || "Login error occurred.",
    //     5000
    //   );
    // }
    catch (error) {
      console.error(error);

      let message = "Login error occurred.";
      switch (error.code) {
        case 'auth/user-not-found':
          message = "No user found with this email.";
          break;
        case 'auth/wrong-password':
          message = "Incorrect password. Please try again.";
          break;
        case 'auth/invalid-email':
          message = "Invalid email format.";
          break;
        case 'auth/too-many-requests':
          message = "Too many failed attempts. Please try again later.";
          break;
        default:
          message = error.message || "Login error occurred.";
          break;
      }

      this.mgsService.showMessage(message, 5000);
    }
  }

  async register(email: string, password: string): Promise<void> {
    try {

    var result = await this.afAuth.createUserWithEmailAndPassword(
      email,
      password
    );
    let value = {};
    value["id"] = result.user.uid;
    value["favorites"] = [];
    value["dailyLimit"] = 0;
    value["createdOn"] = +new Date();
    value["createdAt"] = new Date().toString();
    value["email"] = email;
    value["role"] = "user";
    value["name"] = result.user.displayName ? result.user.displayName : "";
    value["photoURL"] = result.user.photoURL ? result.user.photoURL : "";
    value["uname"] = email;
    value["isSubscribed"] = false;
    value["subscriptionFrom"] = "";
    value["subscriptionTo"] = "";
    value["totalDays"] = 0;
    value["expiryDate"] = "";
    value["web"] = "";
    value["loc"] = "";
    value["job"] = "";
    value["behance"] = "";
    value["dribble"] = "";
    value["pinterest"] = "";
    value["linkedin"] = "";

    const create = await this.afs
      .collection("userMaster")
      .doc(result.user.uid)
      .set(value);
    const admin = await this.afs.doc(`userMaster/${result.user.uid}`);
    admin.valueChanges().subscribe((data) => {
      //console.log(data);
      if (isPlatformBrowser(this.platformId)) {
        this.cacheAndReload(data, false);
      }
      this.user = data;
    });
    // return admin.valueChanges();
    } catch (error) {
    console.error(error);

    let message = "Registration failed.";
    switch (error.code) {
      case 'auth/email-already-in-use':
        message = "Email already exists. Try logging in.";
        break;
      case 'auth/invalid-email':
        message = "Invalid email format.";
        break;
      case 'auth/weak-password':
        message = "Password is too weak. Use at least 6 characters.";
        break;
      default:
        message = error.message || "An error occurred during registration.";
        break;
    }

    this.mgsService.showMessage(message, 5000);
  }
    
    // this.sendEmailVerification();
  }

  async sendEmailVerification() {
    await (await this.afAuth.currentUser).sendEmailVerification();
    this.router.navigate(["/login"]);
  }

  async sendPasswordResetEmail(passwordResetEmail: string) {
    return await this.afAuth.sendPasswordResetEmail(passwordResetEmail);
  }

  async logout() {
    await this.afAuth.signOut();
    sessionStorage.clear();
    window.location.reload();
  }

  get isLoggedIn(): boolean {
    return true;
    // const  user  =  JSON.parse(sessionStorage.getItem('user'));
    // return  user  !==  null;
  }
  async loginWithGoogle() {
    const result = await this.afAuth.signInWithPopup(
      new firebase.GoogleAuthProvider()
    );
    const user = result.user;
    const userRef = this.afs.doc(`userMaster/${user.uid}`);

    userRef
      .valueChanges()
      .pipe(take(1))
      .subscribe(async (data) => {
        if (!data) {
          const newUser = {
            id: user.uid,
            favorites: [],
            dailyLimit: 0,
            createdOn: Date.now(),
            createdAt: new Date().toString(),
            email: user.email,
            role: "user",
            name: user.displayName || "",
            photoURL: user.photoURL || "",
            uname: user.email,
            isSubscribed: false,
            subscriptionFrom: "",
            subscriptionTo: "",
            totalDays: 0,
            expiryDate: "",
            web: "",
            loc: "",
            job: "",
            behance: "",
            dribble: "",
            pinterest: "",
            linkedin: "",
          };
          await userRef.set(newUser);
          this.user = newUser;
          this.cacheAndReload(newUser, false);
        } else {
          this.user = data;
          this.checkSubscriptionStatus(data); // This will cache + reload as needed
        }
      });
  }

  async checkSubscriptionStatus(user: any, from = false): Promise<void> {
    const userRef = this.afs.doc(`userMaster/${user.id}`);
    const snapshot = await userRef.get().toPromise();
    if (!snapshot.exists) return;

    const data: any = snapshot.data();
    const today = Date.now();
    const expiry = new Date(data.expiryDate).getTime();

    if (expiry && expiry < today) {
      // Update Firestore
      data.isSubscribed = false;
      await userRef.update({ isSubscribed: false });
    }

    this.cacheAndReload(data, from);
  }

  cacheAndReload(data: any, from) {
    sessionStorage.setItem("userData", window.btoa(JSON.stringify(data)));
    sessionStorage.setItem(
      "wishlist_item",
      JSON.stringify(data.favorites || [])
    );

    if (isPlatformBrowser(this.platformId)) {
      const returnUrl = sessionStorage.getItem("returnUrl") || "/";
      if (!sessionStorage.getItem("loginReloaded") && !from) {
        sessionStorage.setItem("loginReloaded", "true");
        window.location.href = returnUrl;
      } else {
        sessionStorage.removeItem("loginReloaded");
      }
    }
  }

  async loginWithFacebook() {
    await this.afAuth.signInWithPopup(new firebase.FacebookAuthProvider());
    const returnUrl = sessionStorage.getItem("returnUrl") || "/";
    sessionStorage.removeItem("returnUrl");
    this.router.navigateByUrl(returnUrl);
  }
}
